import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section className="px-[2.4cqw] pt-[1.5cqw]" data-testid="hero-section">
      <motion.div
        className="relative cursor-pointer lifted"
        style={{ borderRadius: "3cqw" }}
        onClick={() => navigate("/vins")}
        role="button"
        aria-label="Découvrir la cave"
        data-testid="hero-cta-button"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      >
        <img
          src="/assets/mockup/hero.jpg"
          alt="La sélection du Bistroquet — des vins de caractère pour de belles tables"
          className="w-full h-auto block select-none no-frame"
          style={{ borderRadius: "3cqw" }}
          data-testid="hero-image"
          draggable={false}
        />
        <h1 className="sr-only" data-testid="hero-headline">
          La sélection du Bistroquet
        </h1>
      </motion.div>
    </section>
  );
}
